/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.discovery.studio.rpc.CollectionsRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type AgentTeam = 'SALES' | 'MARKETING' | 'SERVICE' | unhandledEnumCase;

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type DefaultTierPointsCreditedTierOption =
  | 'diamond'
  | 'elite'
  | 'gold'
  | 'none'
  | 'platinum'
  | unhandledEnumCase;

export type DefaultTypeOption =
  | 'directory_user'
  | 'partner'
  | 'provider'
  | unhandledEnumCase;

export type GetAllCollectionsRequest = {};

export type GetAllCollectionsResponse = {
  items: Default<CollectionPreview[]>;
  total: number;
};

export type GetCollectionBySlugRequest = {
  slug: string;
  offset: Default<number>;
  limit: Default<number>;
  filter?: Filter;
  search?: string;
  sorts: Default<Sort[]>;
};

export type GetCollectionBySlugResponse = {
  entityId: number;
  slug: string;
  collectionType: CollectionType;
  title?: string;
  description?: string;
  tagline?: string;
  htmlPageTitle?: string;
  metaDescription?: string;
  canonicalUrl?: string;
  listingCount: number;
  items: Default<ListingCard[]>;
  total: number;
};

export type Audience = 'ALL' | 'IN_APP' | 'PUBLIC' | unhandledEnumCase;

export type CollectionType = 'STATIC' | 'DYNAMIC' | unhandledEnumCase;

export type DiscoveryStudioError = {
  errorType: ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ErrorType =
  | 'CALLOUT_NOT_FOUND'
  | 'COLLECTION_NOT_FOUND'
  | 'COLLECTION_REFERENCED_BY_CALLOUT'
  | 'INVALID_ENTITY'
  | 'ENTITY_ARCHIVED'
  | 'PLACEMENT_CONFLICT'
  | 'SLUG_CONFLICT'
  | 'SUBMISSION_ALREADY_EXECUTED'
  | 'INVALID_IMAGE'
  | 'IMAGE_UPLOAD_FAILED'
  | 'PUBLISH_LIMIT_EXCEEDED'
  | unhandledEnumCase;

export type ListingCard = {
  listingId: number;
  firstPublishedAt?: number;
  listingName?: string;
  /** @deprecated use getCompanyName() instead. */
  providerName?: string;
  companyName?: string;
  description?: string;
  iconUrl?: string;
  slug?: string;
  installCount?: number;
  products: Default<ProductCard[]>;
  score?: number;
  betaStage?: BetaStage;
  displayTag?: ProductDisplayTag;
  displayTagLabel?: string;
  reviewSummary?: ReviewSummaryCard;
};

export type CollectionPreview = {
  entityId: number;
  name: string;
  slug: string;
  title?: string;
  description?: string;
  audience: Audience;
  previewItems: Default<ListingCardPreview[]>;
  listingCount: number;
};

export type ListingCardPreview = {
  listingId: number;
  name: string;
  slug: string;
  iconUrl: string;
  description: string;
  productTypes: Default<ProductType[]>;
};

export type ProductDisplayTag =
  | 'APP'
  | 'AGENT'
  | 'ASSISTANT'
  | 'CONNECTOR'
  | 'SOLUTIONS_PARTNER'
  | 'WORKFLOW_TEMPLATE'
  | 'FEATURED_AGENT'
  | 'AGENT_TEMPLATE'
  | unhandledEnumCase;

export type ProductType =
  | 'APP'
  | 'THEME'
  | 'MODULE'
  | 'AGENT'
  | 'SOLUTIONS_PARTNER_PROFILE'
  | 'WORKFLOW_TEMPLATE'
  | unhandledEnumCase;

export type AgentType =
  | 'STUDIO'
  | 'ASSISTANT'
  | 'OFF_PLATFORM'
  | unhandledEnumCase;

export type ConnectionType =
  | 'STANDARD'
  | 'HOMEMADE_IFRAME'
  | 'HOMEMADE_EXTERNAL'
  | 'HOMEMADE_MODAL'
  | 'HOMEMADE_PREINSTALLED'
  | 'HOMEMADE_UNIFIED_ACCOUNT'
  | unhandledEnumCase;

export type BetaStage =
  | 'PRIVATE_BETA'
  | 'PUBLIC_BETA'
  | 'PRE_RELEASE'
  | unhandledEnumCase;

export type BaseQueryField =
  | 'LISTING_ID'
  | 'ORDERED_LISTING_ID'
  | 'PRODUCT_ID'
  | 'PRODUCT_TYPE'
  | 'OVERALL_RATING'
  | 'ADJUSTED_OVERALL_RATING'
  | 'REVIEW_COUNT'
  | 'INSTALL_COUNT'
  | 'FIRST_PUBLISHED_AT'
  | 'LISTING_LANGUAGE'
  | 'TIER'
  | 'WORKS_WITH_BREEZE'
  | 'WORKFLOW_ACTIONS'
  | 'WORKFLOW_ACTION_NAME'
  | 'WORKFLOW_ACTION_COMPATIBLE_OBJECT_TYPE_IDS'
  | 'WORKFLOW_ACTION_OBJECT_TYPE_IDS'
  | 'WORKFLOW_ACTION_IS_TOOL'
  | 'WORKFLOW_ACTION_SUPPORTED_CLIENT_APPS'
  | 'WORKFLOW_ACTION_SUPPORTED_CLIENTS'
  | 'PRODUCT_FEATURE_TYPE'
  | 'PRODUCT_FEATURE_NAME'
  | 'PRODUCT_FEATURE_METADATA'
  | 'BUILT_BY_HUBSPOT'
  | 'SOURCE_ID'
  | 'USE_CASES'
  | 'DISPLAY_TAG'
  | 'LISTING_NAME'
  | 'LISTING_SLUG'
  | 'CERTIFIED'
  | 'APP_PARTNER_TIER'
  | 'TECHNOLOGY_PARTNER_TIER'
  | 'CONNECTION_TYPE'
  | 'IS_BREEZE_CONNECTOR'
  | 'SYNC_DIRECTION'
  | 'CATEGORY'
  | 'PRICING_PLAN'
  | 'HUBSPOT_FEATURES'
  | 'SUPPORT_LANGUAGES'
  | 'APP_LANGUAGES'
  | 'TOOL_INTEGRATIONS'
  | 'AGENT_TYPE'
  | 'AGENT_TEAM'
  | 'HAS_UBB'
  | 'PROFILE_SOLUTIONS_PARTNER_TIER'
  | 'PROFILE_BUDGET'
  | 'PROFILE_CATALOG_SERVICES'
  | 'PROFILE_INDUSTRIES'
  | 'PROFILE_LANGUAGES'
  | 'PROFILE_ACCREDITATIONS'
  | 'PROFILE_CERTIFICATIONS'
  | 'PROFILE_SUPPORTED_LISTINGS'
  | 'PROFILE_LOCATION_COUNTRY'
  | 'PROFILE_OFFICE_LOCATION'
  | 'PROFILE_PORTAL_ID'
  | 'OBJECTIVE'
  | 'HUB_PLAN'
  | 'REQUIRED_APP_IDS'
  | 'REQUIRED_AGENT_IDS'
  | 'INSTALLED'
  | 'PORTAL_INSTALLABLE'
  | 'REQUIRED_APPS_INSTALLED'
  | unhandledEnumCase;

export type FeatureType =
  | 'UIE'
  | 'MCP_SERVER'
  | 'WORKFLOW_ACTION'
  | 'WORKFLOW_TRIGGER'
  | unhandledEnumCase;

export type ProductCard = {
  productId?: number;
  sourceId?: string;
  productType?: ProductType;
  agentType?: AgentType;
  agentTeam?: AgentTeam;
  hasUbb?: boolean;
  connectionType?: ConnectionType;
  isBreezeConnector?: boolean;
  certified?: boolean;
  builtByHubSpot?: boolean;
  installed?: boolean;
  portalInstallable?: boolean;
  workflowActions: Default<WorkflowActionCard[]>;
  builtInWorkflowActionTypes: Default<string[]>;
  requiredAppIds: Default<number[]>;
  requiredAgentIds: Default<string[]>;
  workflowObjectives?: string[];
  productFeatures: Default<ProductFeatureCard[]>;
  requiredPermissions?: RequiredPermissions;
  worksWithBreeze: boolean;
  partnerTier?: DefaultTierPointsCreditedTierOption;
  partnerType?: DefaultTypeOption;
};

export type ProductFeatureCard = {
  type?: FeatureType;
  name?: string;
  description?: string;
  metadata: Default<Record<string, string>>;
};

export type RequiredPermissions = {
  requiredScopes: Default<string[]>;
  requiredScopeGroups: Default<string[]>;
};

export type ReviewSummaryCard = {
  overallRating: number;
  reviewCount: number;
  overallAdjustedRating?: number;
};

export type Sort = { field: BaseQueryField; order: SortOrder };

export type SortOrder = 'ASC' | 'DESC' | unhandledEnumCase;

export type WorkflowActionCard = {
  name?: string;
  actionTypeId?: string;
  isTool?: boolean;
  supportedClients: Default<string[]>;
  objectTypeIds: Default<string[]>;
  orderIndex?: string;
  iconType?: string;
  iconUrl?: string;
  iconActionType?: string;
};

export const BooleanFilterQueryTypename =
  'com.hubspot.marketplace.search.models.filters.BooleanFilterQuery';
export const BooleanFilterQueryDiscriminant = 'BooleanFilterQuery';
export const BooleanFilterQueryDiscriminantKey = '@type';
export type BooleanFilterQuery = {
  values: Default<boolean[]>;
  greaterThanOrEqualTo?: boolean;
  lessThanOrEqualTo?: boolean;
  negation: Default<boolean>;
  clause: Default<QueryClause>;
  __typename: 'com.hubspot.marketplace.search.models.filters.BooleanFilterQuery';
} & { '@type'?: 'BooleanFilterQuery' };

export const ExistsFilterQueryTypename =
  'com.hubspot.marketplace.search.models.filters.ExistsFilterQuery';
export const ExistsFilterQueryDiscriminant = 'ExistsFilterQuery';
export const ExistsFilterQueryDiscriminantKey = '@type';
export type ExistsFilterQuery = {
  negation: Default<boolean>;
  clause: Default<QueryClause>;
  __typename: 'com.hubspot.marketplace.search.models.filters.ExistsFilterQuery';
} & { '@type'?: 'ExistsFilterQuery' };

export type Filter = {
  filterGroups: Default<FilterGroup[]>;
  clause: Default<QueryClause>;
  negation: Default<boolean>;
};

export type FilterGroup = {
  filtersByField: Default<Record<string, FilterQuery[]>>;
  clause: Default<QueryClause>;
  negation: Default<boolean>;
};

export const FilterQueryDiscriminantKey = '@type';
export type FilterQuery =
  | BooleanFilterQuery
  | ExistsFilterQuery
  | FloatFilterQuery
  | LongFilterQuery
  | StringFilterQuery;

export const FloatFilterQueryTypename =
  'com.hubspot.marketplace.search.models.filters.FloatFilterQuery';
export const FloatFilterQueryDiscriminant = 'FloatFilterQuery';
export const FloatFilterQueryDiscriminantKey = '@type';
export type FloatFilterQuery = {
  values: Default<number[]>;
  greaterThanOrEqualTo?: number;
  lessThanOrEqualTo?: number;
  negation: Default<boolean>;
  clause: Default<QueryClause>;
  __typename: 'com.hubspot.marketplace.search.models.filters.FloatFilterQuery';
} & { '@type'?: 'FloatFilterQuery' };

export const LongFilterQueryTypename =
  'com.hubspot.marketplace.search.models.filters.LongFilterQuery';
export const LongFilterQueryDiscriminant = 'LongFilterQuery';
export const LongFilterQueryDiscriminantKey = '@type';
export type LongFilterQuery = {
  values: Default<number[]>;
  greaterThanOrEqualTo?: number;
  lessThanOrEqualTo?: number;
  negation: Default<boolean>;
  clause: Default<QueryClause>;
  __typename: 'com.hubspot.marketplace.search.models.filters.LongFilterQuery';
} & { '@type'?: 'LongFilterQuery' };

export type QueryClause = 'AND' | 'OR' | unhandledEnumCase;

export const StringFilterQueryTypename =
  'com.hubspot.marketplace.search.models.filters.StringFilterQuery';
export const StringFilterQueryDiscriminant = 'StringFilterQuery';
export const StringFilterQueryDiscriminantKey = '@type';
export type StringFilterQuery = {
  values: Default<string[]>;
  greaterThanOrEqualTo?: string;
  lessThanOrEqualTo?: string;
  negation: Default<boolean>;
  clause: Default<QueryClause>;
  __typename: 'com.hubspot.marketplace.search.models.filters.StringFilterQuery';
} & { '@type'?: 'StringFilterQuery' };

export type GetCollectionBySlugRequestType =
  Requestify<GetCollectionBySlugRequest>;
export type GetCollectionBySlugResponseType = GetCollectionBySlugResponse;
export type GetCollectionBySlugErrorType = DiscoveryStudioError &
  HubspotMetadata;
export const getCollectionBySlugRpc: ChirpAvroRpcDetails<
  GetCollectionBySlugRequestType,
  GetCollectionBySlugResponseType,
  GetCollectionBySlugErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.discovery.studio.rpc.CollectionsRpc',
  rpcName: 'getCollectionBySlug',
  auth: 'app',
  fingerprint: 'kCQp4mf2m2awardwRdY3HJ3WScrhxELO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAllCollectionsRequestType = Requestify<GetAllCollectionsRequest>;
export type GetAllCollectionsResponseType = GetAllCollectionsResponse;
export type GetAllCollectionsErrorType = DiscoveryStudioError & HubspotMetadata;
export const getAllCollectionsRpc: ChirpAvroRpcDetails<
  GetAllCollectionsRequestType,
  GetAllCollectionsResponseType,
  GetAllCollectionsErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.discovery.studio.rpc.CollectionsRpc',
  rpcName: 'getAllCollections',
  auth: 'app',
  fingerprint: 'wTJXCGMoz02xkA07QQ5q8J3WScrhxELO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
